import React from "react";
import ReactGA, { event } from "react-ga";
import _ from "lodash";
import { getCurrentPage, trackLinkClick } from "../helpers";

class DropDownLinks extends React.Component {
    state = {
        dropdownToggle: false,
    };

    handleDropdownToggle = (e) => {
        e.preventDefault();

        this.setState({
            dropdownToggle: !this.state.dropdownToggle,
        });

        ReactGA.event({
            category: _.startCase(getCurrentPage()),
            action: "Toggle More Info Dropdown",
        });
    };

    render() {
        const { dropdownToggle } = this.state;

        return (
            <div className="drop-down">
                <button
                    className={`drop-down__heading ${
                        dropdownToggle
                            ? "drop-down__heading--open"
                            : "drop-down__heading--closed"
                    }`}
                    onClick={this.handleDropdownToggle}
                >
                    More Info
                </button>
                {dropdownToggle && (
                    <div className="drop-down__content">
                        <p className="drop-down__content__instruction">
                            Click the links below to visit page
                        </p>
                        <ul>
                            <li>
                                <a
                                    className="forward-title"
                                    href="https://betterbybike.info/rent-a-bike/bike-hire-tours/?location=North%20Somerset,Bath,Bristol,South%20Gloucestershire"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    Bike hire & repairs
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a
                                    className="forward-title"
                                    href="https://betterbybike.info/bmx-ramp-parks-racing-tracks/"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    BMX locations
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a
                                    className="forward-title"
                                    href="https://betterbybike.info/shops-and-repair/"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    Bike shops & repairs
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a
                                    className="forward-title"
                                    href="https://betterbybike.info/shops-and-repair/public-bike-pumps/"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    Public bike pumps
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a
                                    className="forward-title"
                                    href="https://betterbybike.info/schemes-and-initiatives/on-street-bike-hangars/"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    On street bike hangers
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default DropDownLinks;



// WEBPACK FOOTER //
// ./src/components/DropDownLinks.js